<template>
  <div class="review">
    <div class="review-top">
      <div class="review-top__name">流量,订单量,排名,Review等</div>
      <div class="review-top__fun">
        <div class="review-top-item">
          <el-select size="mini" placeholder="全部国家" v-model="searchData.countrySite"></el-select>
        </div>
        <div class="review-top-item">
          <el-select size="mini" placeholder="全部店铺" v-model="searchData.store"></el-select>
        </div>
        <div class="review-top-item review-top-item--input">
          <el-input size="mini" placeholder="请输入ASIN,SKU,店铺名称,产品名称或其它" v-model="searchData.text"></el-input>
        </div>
        <div class="review-top__btn">查询</div>
      </div>
    </div>
    <div class="review-table">
      <Table width="1654" :head="reviewTableHead" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ReviewSearchData, AnalysisNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'trafficAndReview',
  components: {
    Table
  },
  data(){
    return {
      /**搜索数据 */
      searchData: new ReviewSearchData(),
      /**订单数量表头 */
      reviewTableHead: AnalysisNewModule.NEWANALYSISTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.review{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &__fun{
      display: flex;
      align-items: center;
    }
    &-item{
      display: flex;
      align-items: center;
      // width: 120px;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 120px;
        }
      }
      &__name{
        border: 1px solid #cecece;
        width: 90px;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 200px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
